export const messages = {
  title: { id: 'admin/promotions.form.conditions.historical-purchase-value' },
  view: {
    title: {
      id: 'admin/promotions.form.conditions.historical-purchase-value.view.title',
    },
  },
}
